export default "__VITE_ASSET__XrZctp5g__"